export default __webpack_public_path__ + "assets/images/b10b7b021f4e23f92f1fa656718ba85b.svg";